import { render, staticRenderFns } from "./RetailerOrders.vue?vue&type=template&id=5d2a1102&"
import script from "./RetailerOrders.vue?vue&type=script&lang=js&"
export * from "./RetailerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports